export default {"src":"/_next/static/media/circlePercent_24.d02eecde.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};